module.exports = __webpack_public_path__ + "img/发展历程s.2c12034f.png";